const salesRouter = [
  {
    path: 'sales-expense-board',
    name: 'SalesExpenseBoard',
    component: () => import('@/views/wxapp/bulletin-board/profit-board-content/sales-expense/index.vue'),
    meta: {
      title: '销售费用看板'
    }
  }
]
export default salesRouter
